import UAParser from 'ua-parser-js';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const hash = require('object-hash') as (obj: object) => string;
import { format } from 'date-fns';
import { captureParticipantDevice, DeviceInfo, DeviceInfoProperties } from '../../api/participant/deviceInfo';

export function getBrowser(): UAParser.IBrowser {
    const parser = new UAParser();
    return parser.getResult().browser;
}

export function getDeviceInfo(): DeviceInfo {
    let resolution = '';
    if (window.screen && window.screen.width && window.screen.height) {
        resolution = `${window.screen.width} x ${window.screen.height}`;
    }

    const parser = new UAParser();
    const result = parser.getResult();

    const properties: DeviceInfoProperties = {
        Browser: result.browser.name,
        BrowserVersion: result.browser.version,
        OperatingSystem: result.os.name,
        Resolution: resolution,
        Device: result.device.model,
        DeviceType: result.device.type
    };

    const deviceIdentifier = hash({ ...properties, BrowserVersion: '' });

    return {
        identifier: deviceIdentifier,
        platform: 'Web',
        properties
    };
}

export function captureDeviceInfo() {
    const offset = format(new Date(), 'xxxxx');
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return captureParticipantDevice({
        offset,
        device: getDeviceInfo(),
        timeZone
    });
}
